import { createAction } from "@reduxjs/toolkit";
import { typeCallbackDataItem } from "./settingsReducer";

export const settingsSetCallbackLoaderAC = createAction(
  "SETTINGS_SET_CALLBACK_LOADER",
  (callbackLoader: boolean) => ({ payload: { callbackLoader } }),
);

export const settingsSetCallbackDataAC = createAction(
  "SETTINGS_SET_CALLBACK_DATA",
  (callbackData: typeCallbackDataItem[]) => ({ payload: { callbackData } }),
);

export const settingsSetCallbackDataSagaAC = createAction(
  "SETTINGS_SET_CALLBACK_DATA_SAGA",
);

export const settingsAddCallbackSagaAC = createAction(
  "SETTINGS_ADD_CALLBACK_SAGA",
  (callbackObj: typeCallbackDataItem) => ({ payload: { callbackObj } }),
);

export const settingsDeleteCallbackSagaAC = createAction(
  "SETTINGS_DELETE_CALLBACK_SAGA",
  (callbackId: string) => ({ payload: { callbackId } }),
);

export const settingsEditUrlCallbackSagaAC = createAction(
  "SETTINGS_EDIT_URL_CALLBACK_SAGA",
  (callbackId: string, callbackUrl: string) => ({
    payload: { callbackId, callbackUrl },
  }),
);
